<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span class="fa fa-table"></span>{{ 'bikeshop.menu.reports' | translate }}</div>
    <div class="loading" *ngIf="loading || runningReport">
      <div class="loader"></div>
    </div>
  </div>
  <div class="content">
    <div class="filter row">
      <div class="col-md-3">
        <b>{{ 'bikeshop.report.report' | translate }}:</b>
        <p-dropdown [options]="availableReports" [(ngModel)]="selectedReport"
          placeholder="{{ 'bikeshop.report.select_report' | translate }}" [group]="true"></p-dropdown>
      </div>
      <div class="col-md-3">
        <div><b>{{ 'bikeshop.report.from_date' | translate }}:</b></div>
        <p-calendar [(ngModel)]="startDate" [showButtonBar]="false" [showIcon]="true" [readonlyInput]="true"
          dateFormat="dd MM yy" placeholder="From Date"></p-calendar>
      </div>
      <div class="col-md-3">
        <div><b>{{ 'bikeshop.report.to_date' | translate }}:</b></div>
        <p-calendar [(ngModel)]="endDate" [showButtonBar]="false" [showIcon]="true" [readonlyInput]="true"
          dateFormat="dd MM yy" placeholder="To Date"></p-calendar>
      </div>
      <div class="col-md-2">
        <button pButton style="margin-top:24px;" type="button" class="full-width p-button-raised"
          label="{{ 'bikeshop.report.run_report' | translate }}" (click)="runReport()"
          [disabled]="!selectedReport || runningReport"></button>
      </div>
      <div class="col-md-1">
        <div *ngIf="reportRan">
          <span style="position: absolute;top: 45%;left: 30%; cursor: pointer;" (click)="downloadFile()"><i
              class="fa fa-download fa-2x" aria-hidden="true"></i></span>
          <!--<button pButton style="margin-top:24px;" type="button" class="full-width p-button-raised"
                  (click)="runReport()" [disabled]="!selectedReport || runningReport">

          </button>-->
        </div>
      </div>
    </div>

    <div *ngIf="getReportDescription()" class="report-description" [innerHTML]="getReportDescription()"></div>

    <div style="overflow-x: auto;">
      <div class="report" [ngClass]="{'no-border': !useTableBorder}" *ngIf="!runningReport && reportData.length>0">
        <div *ngFor="let row of reportData;let i = index" class="report-row" [ngClass]="{'row-header': i===0}">
          <div *ngFor="let column of row" class="report-column">
            {{column.indexOf("\<br\/\>")>-1 ? "" : column }}
          </div>
        </div>
      </div>
    </div>
  </div>
